export const CHANGE_ACTIVE_ITEM_TIMEOUT = 300

export const PREVIEW_VIEW_TYPE_MIN_SCREEN_WIDTH = 848 // px

export const PREVIEW_VIEW_TYPE_MAX_WIDTH_BREAKPOINT = `(max-width: ${PREVIEW_VIEW_TYPE_MIN_SCREEN_WIDTH}px)`
